var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.classNames,style:(_vm.styles),attrs:{"alt":_vm.alt,"loading":_vm.loading,"src":_vm.otherUrl,"lazy-load":_vm.lazyLoad},on:{"error":_vm.error,"click":_vm.handerClick,"load":_vm.load}})
}
var staticRenderFns = []

export { render, staticRenderFns }